export const personal = [
    { name: 'Anniversary Party - No Charge for Admission / Invite Only' },
    { name: 'Anniversary Party' },
    { name: 'Baby Shower' },
    { name: 'Banquet' },
    { name: 'Baptism' },
    { name: 'Bar Mitzvah' },
    { name: 'Bat Mitzvah' },
    { name: 'Birthday Party' },
    { name: 'Sweet 16' },
    { name: 'Bridal Shower' },
    { name: 'Classical Dance Show' },
    { name: 'First Communion' },
    { name: 'Funeral Service' },
    { name: 'Graduation Ceremony' },
    { name: 'Memorial Service' },
    { name: 'Retirement Party' },
    { name: 'Picnic (no water activities)' },
    { name: 'Reunion Party' },
    { name: 'Block Party' },
    { name: 'Holiday Celebration Event - Not Haunted' },
    { name: 'New Years Eve Party - Invite Only' },
    { name: 'Quinceanera' },
    { name: 'Recital' },
    { name: 'Religious Assembly' },
    { name: 'Social Reception' },
    { name: 'Wedding Reception' },
    { name: 'Wedding Ceremony' },
    { name: 'Wedding Rehearsal' },
    { name: 'Brunch' },
    { name: 'Wedding Shower' },
    { name: 'Private Dinner/Lunch' },
    { name: 'Housewarming Party' },
    { name: 'Engagement Party' },
    { name: 'Celebration of Life' },
];


export const prof = [

    { name: 'Amateur & Professional Association Meeting' },
    { name: 'Antique Show' },
    { name: 'Award Presentation' },
    { name: 'Book Signing' },
    { name: 'Auction' },
    { name: 'Church Meeting/Services' },
    { name: 'Concert Symphony' },
    { name: 'Concert Holiday Music' },
    { name: 'Dance Recital' },
    { name: 'Fundraising Dinner' },
    { name: 'Education Exhibition' },
    { name: 'Flea Market' },
    { name: 'Fundraising Breakfast' },
    { name: 'Fundraising Brunch' },
    { name: 'Lecture' },
    { name: 'Luncheon' },
    { name: 'Photo Shoot' },
    { name: 'Seminar' },
    { name: 'Speaking Engagement' },
    { name: 'Swap Meet' },
    { name: 'Trade Show' },
    { name: 'Beauty Pageant' },
    { name: 'Concert Folk Music' },
    { name: 'Concert Classical' },
    { name: 'Concert Christian' },
    { name: 'Concert Country' },
    { name: 'Convention' },
    { name: 'Fashion Show' },
    { name: 'Consumer Show' },
    { name: 'Video Gaming Event' },
    { name: 'Comedy Show' },
    { name: 'Concert Pop/Cover Band' },
    { name: 'Arts & Crafts Festival' },
    { name: 'Festival' },
    { name: 'Festival & Cultural Event' },
    { name: 'Film Screening' },
    { name: 'Film Shoot - No Stunt Exposure Allowed' },
    { name: 'Music Video' },
    { name: 'Video Shoot' },
    { name: 'Play Theatre Event' },
    { name: 'Street Fair' },
    { name: 'Talent Show - No Hip Hop/RAP/Heavy Metal or Hard Rock Music' },
    { name: 'Theatrical Stage Performance/Play' },
    { name: 'Concert 50s/60/70/80/90' },
    { name: 'Concert - Jazz and Jam' },
    { name: 'Concert Instrumental' },
    { name: 'Yoga Event' },
    { name: 'After Prom Party (school sponsored)' },
    { name: 'Business Meeting' },
    { name: 'Club Meeting' },
    { name: 'Chess Event' },
    { name: 'Poetry Reading' },
    { name: 'Prom School Dance' },
    { name: 'Talent Show (Children Only)' },
    { name: 'Easter Egg Hunt' },
    { name: 'Expos' },
    { name: 'Lecture/Workshop' },
    { name: 'Conference' }
];


export const spt = [
    { name: 'Baseball' },
    { name: 'Basketball' },
    { name: 'Bowling' },
    { name: 'Football(Flag & Touch)' },
    { name: 'Golf' },
    { name: 'Disc Golf' },
    { name: 'Softball' },
    { name: 'Volleyball' },
    { name: 'Kickball' },
    { name: 'Lacrosse' },
    { name: 'Pickleball' },
    { name: 'Racquetball' },
    { name: 'Soccer - YOUTH ONLY' },
    { name: 'Tennis' },
    { name: 'Baseball' },
    { name: 'Football(Flag & Touch)' },
    { name: 'Softball' },
    { name: 'Baseball' },
    { name: 'Volleyball' },
    { name: 'Hockey' },
    { name: 'Golf' },
    { name: 'Kickball' },
    { name: 'Running(5k or 10K)' },
    { name: 'Track and Field(indoor)' },
    { name: 'Walking' },
    { name: 'Tennis' },
    { name: 'Pickleball' },
];

export const vdr = [
    { name: 'Antiques & Collectibles Vendors' },
    { name: 'Apparel & Accessories' },
    { name: 'Arts & Craft Vendors' },
    { name: 'Disc-Jockey (for private events with less than 200 attendees)' },
    { name: 'Food & Drink (Non-alcoholic Drink)' },
    { name: 'Gift Wrap Booths' },
    { name: 'Photo Booth' },
    { name: 'Photographer/Videographer' },
    { name: 'Produce & Floral Vendors' },
    { name: 'Products Demos - Static' },
    { name: 'Product or Service Display Exhibits' },
    { name: 'Retail Carts' },
    { name: 'Souvenir Sales' },
    { name: 'Sports & Camping Equipment' },
    { name: 'Vehicles, Equipment, or Hardware Sales on Display - Static' },
];

export const states = [
    { name: 'AL' },
    { name: 'AK' },
    { name: 'AZ' },
    { name: 'AR' },
    { name: 'CA' },
    { name: 'CO' },
    { name: 'CT' },
    { name: 'DC' },
    { name: 'DE' },
    { name: 'FL' },
    { name: 'GA' },
    { name: 'HI' },
    { name: 'ID' },
    { name: 'IL' },
    { name: 'IN' },
    { name: 'IA' },
    { name: 'KS' },
    { name: 'KY' },
    { name: 'LA' },
    { name: 'ME' },
    { name: 'MD' },
    { name: 'MA' },
    { name: 'MI' },
    { name: 'MN' },
    { name: 'MS' },
    { name: 'MO' },
    { name: 'MT' },
    { name: 'NE' },
    { name: 'NV' },
    { name: 'NH' },
    { name: 'NJ' },
    { name: 'NM' },
    { name: 'NY' },
    { name: 'NC' },
    { name: 'ND' },
    { name: 'OH' },
    { name: 'OK' },
    { name: 'OR' },
    { name: 'PA' },
    { name: 'RI' },
    { name: 'SC' },
    { name: 'SD' },
    { name: 'TN' },
    { name: 'TX' },
    { name: 'UT' },
    { name: 'VT' },
    { name: 'VA' },
    { name: 'WA' },
    { name: 'WV' },
    { name: 'WI' },
    { name: 'WY' }
];